import { useCallback, useEffect } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

import { useAppDispatch } from "./use-redux";

import { setDeviceFingerPrint } from "~/store/global";

export const useDeviceFingerPrint = () => {
  const dispatch = useAppDispatch();

  const updateDeviceFingerprint = useCallback(() => {
    const fpPromise = FingerprintJS.load();
    if (fpPromise) {
      fpPromise
        .then((fp: any) => fp.get())
        .then((result: any) => {
          const deviceFP = result.visitorId;
          dispatch(setDeviceFingerPrint(deviceFP));
        });
    }
  }, [dispatch]);

  // Run the effect once when the component mounts to start the fingerprint calculation
  useEffect(() => {
    updateDeviceFingerprint();
  }, [updateDeviceFingerprint]);

  return {};
};
